import getValueFromQueryParams from "../utils/parse-query-params";
import fetchGraphql from "../utils/graphql";
import fetchShowroomApi from "../utils/fetch-showroom-api";

customElements.component = 'showroom-purchased-dresses';

if (!customElements.get(customElements.component)) {
  const selectors = {
    html: "html",
    loader: ".js-loader",
    nav: ".js-showroom-purchased-dresses-nav",
    select: ".js-showroom-purchased-dresses-select",
    content: ".js-showroom-purchased-dresses-content",
    slider: ".js-showroom-purchased-dresses-slider",
    modal: ".js-modal",
    modalInner: ".js-modal-inner",
    modalClose: ".js-close-modal",
    modalHow: ".js-modal-how",
    modalHowTrigger: ".js-modal-trigger",
    visible: "visible"
  }

  class ShowroomPurchasedDresses extends HTMLElement {
    constructor() {
      super();

      this.html = document.querySelector(selectors.html);
      this.loader = this.querySelector(selectors.loader);
      this.nav = this.querySelector(selectors.nav);
      this.select = this.querySelector(selectors.select);
      this.content = this.querySelector(selectors.content);
      this.modals = this.querySelectorAll(selectors.modal);
      this.modalClose = this.querySelectorAll(selectors.modalClose);
      this.modalHow = this.querySelector(selectors.modalHow);
      this.modalHowTrigger = document.querySelector(selectors.modalHowTrigger);
      this.translations = window.showroom_purchased_dresses_t;
      this.icons = window.showroom_purchased_dresses_icons;
      this.allProducts = [];
      this.sections = [];

      this.productByHandleQuery = `
        query ProductByHandle($handle: String!) {
          productByHandle(handle: $handle) {
            id
            handle
            title
            vendor
            images(first: 250) {
              nodes {
                url,
                altText
              }
            }
            variants(first: 50) {
              nodes {
                id
                availableForSale
                title
                selectedOptions {
                  name
                  value
                }
                image {
                  url
                }
                price {
                  amount
                }
                compareAtPrice {
                  amount
                }
              }
            }
          }
        }
      `

      this.data = {};

      this.init();
    }

    handleModalCloseOutside(e, modal) {
      const modalInner = modal.querySelector(selectors.modalInner);

      if (!modalInner.contains(e.target)) {
        this.closeModal(modal);
      }
    }

    openModal(el) {
      this.html.classList.add("overflow-hidden");
      el.classList.add("opened");
    }

    closeModal(el) {
      this.html.classList.remove("overflow-hidden");
      el.classList.remove("opened");
    }

    async getData() {
      const showroomId = getValueFromQueryParams("id") || window.localStorage.getItem("last_viewed_showroom");

      if (showroomId) {
        this.data = await fetchShowroomApi(`/showrooms/${showroomId}`);

        const url = new URL(window.location);

        url.searchParams.set("id", this.data.id);
        window.history.pushState({}, '', url);

        window.localStorage.setItem("last_viewed_showroom", showroomId);

        if (!this.data.currentCustomerIsOwner) {
          this.modalHowTrigger.classList.add("hidden");
        }
      } else if (!window.is_customize) {
        window.location.pathname = "/pages/showroom"
      }
    }

    async getProducts() {
      const productsHandles = [];
      const requests = [];

      this.data.bridesmaids.forEach(bridesmaid => {
        if (bridesmaid.bridesmaidsDresses) {
          bridesmaid.bridesmaidsDresses.forEach(dress => {
            if (dress.isPurchased) {
              const { shopifyProductHandle } = dress;

              if (!productsHandles.includes(shopifyProductHandle)) {
                productsHandles.push(shopifyProductHandle)
              }
            }
          });
        }
      })

      productsHandles.forEach(handle => {
        requests.push(
            fetchGraphql({
              query: this.productByHandleQuery,
              variables: {
                handle: handle
              }
            })
        );
      })

      const results = await Promise.all(requests);

      results.forEach(result => {
        if (result && result.data.productByHandle) {
          const { productByHandle } = result.data;
          this.allProducts.push(productByHandle)
        }
      });
    }

    renderNav() {
      this.data.bridesmaids.forEach((obj, index) => {
        this.nav.innerHTML += `<a href="#${obj.id}" ${index === 0 ? `class="active"` : ""}>${obj.name || "Name"}</a>`
        this.select.innerHTML += `<option value="${obj.id}" ${index === 0 ? `selected` : ""}>${obj.name || "Name"}</option>`
      })

      this.nav.querySelectorAll("a").forEach(link => {
        link.addEventListener("click", this.handleNavClick.bind(this));
      });

      this.select.addEventListener("change", e => {  
        const targetId = e.target.value;
        const section = document.getElementById(targetId);

        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      })
    }

    renderLayout() {
      this.data.bridesmaids.forEach((obj, index) => {
        if (obj.bridesmaidsDresses.length) {
          const objProducts = [];

          obj.bridesmaidsDresses.forEach(dress => {
            this.allProducts.forEach(product => {
              const variantImage  = product.images.nodes.filter(img => img.altText && img.altText.includes(dress.dressColor))[0] || null;
              let isVariantAdded = false;

              if (product.handle === dress.shopifyProductHandle && dress.isPurchased) {
                product.variants.nodes.forEach(variant => {
                  variant.selectedOptions.forEach(option => {
                    if (option.value === dress.dressColor && !isVariantAdded) {
                      objProducts.push({
                        ...product,
                        variant,
                        variantImage,
                        color: option.value
                      });

                      isVariantAdded = true;
                    }
                  })
                })
              }
            })
          })

          this.content.innerHTML += `
            <div class="showroom-select-dresses__top" id="${obj.id}">
                <div class="showroom-select-dresses__number">${index + 1}</div>
                <div>
                    <div class="showroom-select-dresses__role">${this.translations.bridesmaid}</div>
                    <div class="showroom-select-dresses__name">${obj.name || "Name"}</div>
                </div>
            </div>
            <div class="swiper showroom-select-dresses__slider js-showroom-purchased-dresses-slider" data-slider-id="${obj.id}">
                <div class="swiper-wrapper">
                    ${objProducts.map(product => {
          return `<div class="swiper-slide">${this.renderProductCard(product, obj.id, product.color)}</div>`
        }).join("")}
                    <div class="swiper-slide">${this.renderEmptyCard()}</div>
                </div>
                ${objProducts.length ? `
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-pagination"></div>
                  <div class="swiper-button-next"></div>
                ` : ``}
            </div>
          `
        } else {
          this.content.innerHTML += `
            <div class="showroom-select-dresses__top" id="${obj.id}">
                <div class="showroom-select-dresses__number">${index + 1}</div>
                <div>
                    <div class="showroom-select-dresses__role">${this.translations.bridesmaid}</div>
                    <div class="showroom-select-dresses__name">${obj.name || "Name"}</div>
                </div>
            </div>
            <div class="swiper showroom-select-dresses__slider js-showroom-purchased-dresses-slider" data-slider-id="${obj.id}">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        ${this.renderEmptyCard()}
                    </div>
                </div>
            </div>
          `
        }
      })

      this.sections = this.content.querySelectorAll(".showroom-select-dresses__top");
    }

    renderProductCard(product) {
      if (product) {
        return `
          <div class="showroom-product-card">
            <div class="showroom-product-card-image">
                <img src="${product.variantImage ? product.variantImage.url : product.images.nodes[0].url}" alt="${product.title}">
                <a href="/products/${product.handle}" class="showroom-product-card-button">${this.translations.viewProduct}</a>
            </div>
            <div class="showroom-product-card-vendor">${product.vendor}</div>
            <div class="showroom-product-card-title">${product.title}</div>
            <div class="showroom-product-card-price">$${product.variant.price.amount}</div>
          </div>
        `
      }
    }

    renderEmptyCard() {
      return `
        <div class="showroom-empty-card">
            ${this.icons.dress}
            ${this.translations.noPurchased}
        </div>
      `
    }

    handleNavClick(event) {
      event.preventDefault();
      const targetId = event.target.getAttribute("href").slice(1);
      const section = document.getElementById(targetId);

      if (section) {
        section.scrollIntoView({ behavior: "smooth" });

        setTimeout(() => {
          this.nav.querySelectorAll("a").forEach(link => link.classList.remove("active"));
          event.target.classList.add("active");
        }, 750);
      }
    }

    handleScroll() {
      const scrollPosition = window.scrollY + window.innerHeight / 2;

      if (window.scrollY === 0) {
        this.nav.querySelectorAll("a").forEach(link => link.classList.remove("active"));
        this.nav.querySelector("a").classList.add("active");
        return;
      }

      this.sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute("id");

        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          this.nav.querySelectorAll("a").forEach(link => {
            link.classList.remove("active");
            if (link.getAttribute("href").slice(1) === sectionId) {
              link.classList.add("active");
            }
          });
        }
      });
    }

    initEvents() {
      this.modals && this.modals.forEach(modal => {
        modal.addEventListener("click", e => this.handleModalCloseOutside(e, modal))
      })

      this.modalClose && this.modalClose.forEach(el => {
        el.addEventListener("click", () => this.closeModal(el.closest(selectors.modal)))
      })

      this.modalHowTrigger && this.modalHowTrigger.addEventListener("click", () => this.openModal(this.modalHow))
    }

    initSliders() {
      this.sliders = this.querySelectorAll(selectors.slider);

      this.sliders && this.sliders.forEach(slider => {
        const sliderID = slider.getAttribute("data-slider-id");

        this.initSlider(`${selectors.slider}[data-slider-id="${sliderID}"]`);
      })
    }

    initSlider(selector) {
      new Swiper(selector, {
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
          nextEl: `${selector} .swiper-button-next`,
          prevEl: `${selector} .swiper-button-prev`
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        breakpoints: {
          768: {
            slidesPerView: 2
          },
          991: {
            slidesPerView: 4
          }
        }
      });
    }

    async init() {
      await this.getData();
      await this.getProducts();
      this.renderNav();
      this.renderLayout();
      this.initSliders();
      this.initEvents();

      window.addEventListener("scroll", this.handleScroll.bind(this));

      this.loader.classList.remove(selectors.visible);
    }
  }

  customElements.define(customElements.component, ShowroomPurchasedDresses);
}
